import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("aPVyw"), parcelRequire.load("9f8mp"), parcelRequire.load("h9Kbu"), parcelRequire.load("97gFA"), parcelRequire.load("h3v9b"), parcelRequire.load("jkk6G"), parcelRequire.load("lfyA4"), parcelRequire.load("b10RR"), parcelRequire.load("dZMz1"), parcelRequire.load("aZxtm")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("aPVyw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("9f8mp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("h9Kbu")} />
  <link rel="modulepreload" href={parcelRequire.resolve("97gFA")} />
  <link rel="modulepreload" href={parcelRequire.resolve("h3v9b")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jkk6G")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lfyA4")} />
  <link rel="modulepreload" href={parcelRequire.resolve("b10RR")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dZMz1")} />
  <link rel="modulepreload" href={parcelRequire.resolve("aZxtm")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
